import { render, staticRenderFns } from "./MixExam.vue?vue&type=template&id=31317db0&"
import script from "./MixExam.vue?vue&type=script&lang=js&"
export * from "./MixExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports